<template bindable="text, highlight">
  <require from="framework/value_converters/text-highlight"></require>

  <span repeat.for="split of text | textHighlight:highlight" class="${split.highlight ? '--highlight' : ''}">${split.substring}</span>
</template>
